<template>
  <div>
    <div class="text__container--collapse-toggle" @click="isOpen = !isOpen">
      <h2 class="heading-h3 heading-underlined text__header--collapsable">{{ title }}</h2>
      <span class="text__btn--open icon--showright" :class="iconClass" />
    </div>
    <div v-if="isOpen" class="text__container--collapsable-content" v-html="content" />
  </div>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
  title: { type: String, required: true },
  content: { type: String, required: true },
  blockId: { type: Number, default: null },
});

const isOpen = ref(false);

function openOnEvent(event: Event) {
  if (event instanceof CustomEvent && event.detail?.blockId === props.blockId) {
    isOpen.value = true;
  }
}

onMounted(() => window.addEventListener('open-text', openOnEvent));
onBeforeUnmount(() => window.removeEventListener('open-text', openOnEvent));

const iconClass = computed(() => (isOpen.value ? 'icon--angle_down' : 'icon--angle_right'));
</script>
